import { call, put, select, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "./types";
import { failure, success } from "./actions";
import { snack } from "components/GlobalSnackbar";
import { getError } from "utils";
import { RootState } from "../root_reducer";
import { api, cacheDados } from "configs";
import { IFeriado } from "@deltasge/marauders-map";

interface IRequest {
  type: typeof ActionTypes.REQUEST;
  payload: number;
}

function* request({ payload }: IRequest) {
  try {
    const {
      usuario: { usuario },
    }: RootState = yield select();

    if (!usuario) {
      throw new Error("Usuário não encontrado");
    }

    const cache24h = 60 * 24;
    const key = `feriado-${payload}-${usuario?.escolaId}`;
    const cache = cacheDados.get<string[]>(key);
    if (Array.isArray(cache)) {
      yield put(success(cache));
    } else {
      const { data } = yield call(api.get, `feriado/`, {
        params: {
          where: {
            anoLetivo: payload,
          },
        },
      });
      if (Array.isArray(data) && Array.isArray(data[0]) && data[0].length > 0) {
        const feriados = data[0][0] as IFeriado;
        if (typeof feriados.feriados == "string") {
          const datas = feriados.feriados
            .split(",")
            .filter((f) =>
              /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])$/.test(f)
            )
            .map(
              (m) =>
                `${payload}-${m.trim().substr(3, 2)}-${m.trim().substr(0, 2)}`
            );
          yield put(success(datas));
          cacheDados.set(key, datas, cache24h);
        }
      }
    }
  } catch (error) {
    yield put(failure());
    snack.error(getError(error));
  }
}
export const sagas = takeLatest([ActionTypes.REQUEST], request);
